import React from 'react'
import { Navigate, RouteObject } from 'react-router-dom'
import loadable from '@loadable/component'
import { SiteUrls } from '@/routes/siteUrls'

const MainLayout = loadable(() => import('@/layouts/OnPremiseMainLayout'))

// workspace
const WorkspaceMain = loadable(() => import('@/pages/Workspace/Main'))
const WorkspaceSettings = loadable(() => import('@/pages/Workspace/Settings'))
const WorkspaceNotificationSettings = loadable(() => import('@/pages/Workspace/NotificationSettings'))
const WorkspaceTaskList = loadable(() => import('@/pages/Workspace/WorkspaceTaskList'))
const WorkspaceImportModel = loadable(() => import('@/pages/Workspace/ImportModel'))

// storage
const Storage = loadable(() => import('@/pages/Storage/Storage'))

// project
const Projects = loadable(() => import('@/pages/Project/Projects'))
const ProjectMain = loadable(() => import('@/pages/Project/Main'))
const ProjectModelDownloadHistory = loadable(() => import('@/pages/Project/ModelDownloadHistory'))
const Pipeline = loadable(() => import('@/pages/RenewedPipeline/RenewedPipeline'))

// labeling
const LabelingDetail = loadable(() => import('@/pages/Labeling/Detail/DetailMerged'))

// result
const ModelResult = loadable(() => import('@/pages/Result/Model/ModelResult'))
const ValidationResult = loadable(() => import('@/pages/Result/Validation/ValidationResult'))
const InferenceResult = loadable(() => import('@/pages/Result/Inference/InferenceResult'))
const IeModelResult = loadable(() => import('@/pages/Result/Model/IeModelResult'))
const IeValidationResult = loadable(() => import('@/pages/Result/Validation/IeValidationResult'))
const IeInferenceResult = loadable(() => import('@/pages/Result/Inference/IeInferenceResult'))

// inquiry
const InquiryList = loadable(() => import('@/pages/User/Inquiries/List'))
const InquiryDetail = loadable(() => import('@/pages/User/Inquiries/Detail'))

// Manual
const Manual = loadable(() => import('@/pages/Manual/StaticManual'))

const onPremiseRoutes = (): RouteObject[] => [
  {
    path: '/manual/list',
    element: <Manual />,
  },
  {
    path: SiteUrls.Main._, // FIXME: ???
    element: <MainLayout />,
    children: [
      {
        path: SiteUrls.Main.Workspace.Main,
        element: <WorkspaceMain />,
        children: [
          {
            path: SiteUrls.Main.Workspace.Settings,
            element: <WorkspaceSettings />,
          },
          {
            path: SiteUrls.Main.Workspace.WorkspaceTaskList,
            element: <WorkspaceTaskList />,
          },
          {
            path: SiteUrls.Main.Workspace.NotificationSettings,
            element: <WorkspaceNotificationSettings />,
          },
          {
            path: SiteUrls.Main.Workspace.ImportModel,
            element: <WorkspaceImportModel />,
          },
          {
            path: SiteUrls.Main.Workspace.Projects,
            element: <Projects />,
          },
          {
            path: SiteUrls.Main.Workspace.Storage._,
            element: <Storage />,
          },
          {
            path: SiteUrls.Main.Workspace.Storage.folder(':id'),
            element: <Storage />,
          },
        ],
      },
      {
        path: SiteUrls.Main.Project.Main(':projectId'),
        element: <ProjectMain />,
        children: [
          {
            path: SiteUrls.Main.Project.Pipeline(':projectId'),
            element: <Pipeline />,
          },
          {
            path: SiteUrls.Main.Project.ModelDownloadHistory(':projectId'),
            element: <ProjectModelDownloadHistory />,
          },
        ],
      },
      {
        path: SiteUrls.Main.Project.Labeling.Detail(':projectId', ':nodeId'),
        element: <LabelingDetail />,
      },
      {
        path: SiteUrls.Main.Project.Result.Model(':projectId', ':nodeId'),
        element: <ModelResult />,
      },
      {
        path: SiteUrls.Main.Project.Result.ModelIe(':projectId', ':nodeId'),
        element: <IeModelResult />,
      },
      {
        path: SiteUrls.Main.Project.Result.Validation(':projectId', ':nodeId'),
        element: <ValidationResult />,
      },
      {
        path: SiteUrls.Main.Project.Result.ValidationIe(':projectId', ':nodeId'),
        element: <IeValidationResult />,
      },
      {
        path: SiteUrls.Main.Project.Result.Inference(':projectId', ':nodeId'),
        element: <InferenceResult />,
      },
      {
        path: SiteUrls.Main.Project.Result.InferenceIe(':projectId', ':nodeId'),
        element: <IeInferenceResult />,
      },
      {
        path: SiteUrls.Main.User.Inquiries,
        element: <InquiryList />,
      },
      {
        path: SiteUrls.Main.User.InquiryDetail(':id'),
        element: <InquiryDetail />,
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to={SiteUrls.Main.Workspace.Main} replace />,
  },
]

export default onPremiseRoutes
